import { Pipe, PipeTransform } from '@angular/core';

import { userStatusIcon } from '../constants/constants';

@Pipe({ name: 'userStatusIcon', standalone: true })
export class UserStatusIconPipe implements PipeTransform {
  transform(userData: any) {
    return userStatusIcon(userData);
  }
}
